import React from 'react';
import { Order } from '../types';

interface PaymentsTabProps {
  pendingPayments: Order[];
  onReviewPayment: (payment: Order) => void;
}

export const PaymentsTab: React.FC<PaymentsTabProps> = ({ pendingPayments, onReviewPayment }) => {
  return (
    <div style={{
      background: 'white',
      padding: '2rem',
      borderRadius: '15px',
      boxShadow: '0 5px 20px rgba(0,0,0,0.1)',
      marginBottom: '2rem'
    }}>
      <h2 style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#333', marginBottom: '1.5rem' }}>
        Pending Manual Payments
      </h2>

      {pendingPayments.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '3rem', color: '#666' }}>
          No pending manual payments
        </div>
      ) : (
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ borderBottom: '2px solid #eee' }}>
                <th style={{ padding: '1rem', textAlign: 'left', fontWeight: '600', color: '#333' }}>Customer</th>
                <th style={{ padding: '1rem', textAlign: 'left', fontWeight: '600', color: '#333' }}>Payment Method</th>
                <th style={{ padding: '1rem', textAlign: 'left', fontWeight: '600', color: '#333' }}>Amount</th>
                <th style={{ padding: '1rem', textAlign: 'left', fontWeight: '600', color: '#333' }}>Date</th>
                <th style={{ padding: '1rem', textAlign: 'left', fontWeight: '600', color: '#333' }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {pendingPayments.map((payment) => (
                <tr key={payment._id} style={{ borderBottom: '1px solid #f0f0f0' }}>
                  <td style={{ padding: '1rem' }}>
                    <div>
                      <div style={{ fontWeight: '600' }}>{payment.customerName}</div>
                      <div style={{ fontSize: '0.9rem', color: '#666' }}>{payment.customerEmail}</div>
                    </div>
                  </td>
                  <td style={{ padding: '1rem' }}>
                    🇨🇴 {payment.paymentMethod?.replace('manual_', '').replace('_', ' ')}
                  </td>
                  <td style={{ padding: '1rem' }}>
                    <span style={{ fontWeight: '600' }}>
                      ${((payment.amount || 0) / 100).toFixed(2)} {payment.currency}
                    </span>
                  </td>
                  <td style={{ padding: '1rem' }}>
                    {new Date(payment.createdAt).toLocaleDateString()}
                  </td>
                  <td style={{ padding: '1rem' }}>
                    <button
                      onClick={() => onReviewPayment(payment)}
                      style={{
                        padding: '0.5rem 1rem',
                        background: '#007bff',
                        color: 'white',
                        border: 'none',
                        borderRadius: '5px',
                        cursor: 'pointer',
                        fontSize: '0.9rem'
                      }}
                    >
                      Review
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};
